import { Navigate } from "react-router-dom";
import { useAuth } from "@workos-inc/authkit-react";
import { hasWorkOsConfig } from "../lib/config";
import { beginWorkOsSignIn } from "../lib/workos-sign-in";

/**
 * AuthKit only exchanges the OAuth `code` while the browser is still on the
 * configured redirect path (`/callback`). This page must render outside the
 * authenticated AppShell gate so initialization can finish before navigation.
 */
export function CallbackPage() {
  if (!hasWorkOsConfig) {
    return <Navigate to="/" replace />;
  }
  return <CallbackWait />;
}

function CallbackWait() {
  const { isLoading, user, signIn } = useAuth();

  if (isLoading) {
    return (
      <section className="setup-gate">
        <h1>Completing sign-in</h1>
        <p className="muted">Finishing the WorkOS AuthKit handoff…</p>
      </section>
    );
  }

  if (user) {
    return <Navigate to="/" replace />;
  }

  return (
    <section className="setup-gate">
      <h1>Sign-in did not complete</h1>
      <p>
        AuthKit could not establish a session from this callback. Clear site data for this origin if
        a previous session left a bad refresh token, then try again from the app (not by opening
        Hosted AuthKit directly).
      </p>
      <div className="header-actions">
        <button type="button" className="btn primary" onClick={() => beginWorkOsSignIn(signIn)}>
          Retry sign-in
        </button>
        <a className="btn ghost" href="/">
          Back to app
        </a>
      </div>
    </section>
  );
}
